//@flow
/**
 * Question actions
 * @module question/lib
 */
import React from 'react'
import { render, unmountComponentAtNode } from 'react-dom'
import Question from '../../components/Question'

import { generateQuizPreloadPath } from '@lrg/lln-quiz-common/lib/quiz/lib'
import store from '../store'
import { fetchQuestion, setPreloadQuizPath } from './actions'

/**
 * Preloads questions, both components and assets.
 * @memberof question/lib
 */
export async function preloadQuestions() {
  const state = store.getState()
  // don't preload if the learner is complete
  if (
    state.learner.complete ||
    state.learner.currentQuestionId === 'false' ||
    state.learner.testLevel === 'dlrq' ||
    state.learner.testLevel === 'dp' ||
    state.learner.testLevel === 'dpcourse'
  ) {
    return
  }
  let path = []
  try {
    path = generateQuizPreloadPath(
      state.learner.testLevel,
      state.learner.currentQuestionId,
    )
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log("get path error : generateQuizPreloadPath")
  }
  store.dispatch(setPreloadQuizPath(path))
  let questionId
  //eslint-disable-next-line no-cond-assign
  while ((questionId = path.shift())) {
    store.dispatch(fetchQuestion(questionId))
    await questionFetched(store, questionId)
    const { questions } = store.getState()
    const question = questions.questions.get(questionId)
    await loadDisplayElementsAndAssets(question.toJS())
    const { learner } = store.getState()
    // if the learner has progressed past the current head
    if (path.indexOf(learner.currentQuestionId) > 0) {
      // then cut off the head, not including the current question, we can assume that
      // is loading already via the actual quiz
      path = path.slice(path.indexOf(learner.currentQuestionId) + 1)
    }
  }
}

/**
 * Resolves when question has been fetched.
 * Note: This will never resolve if question loading isn't triggered somehow.
 * @memberof question/lib
 */
async function questionFetched(store, questionId) {
  const { questions } = store.getState()
  if (questions.questions.has(questionId)) {
    // if question already fetched return immediately
    return
  }
  return new Promise(resolve => {
    store.subscribe(() => {
      // wait for the questions to be defined
      const { questions } = store.getState()
      if (questions.questions.has(questionId)) {
        resolve()
      }
    })
  })
}

/**
 * Loads the questions display elements and assets.
 * @memberof question/lib
 */
async function loadDisplayElementsAndAssets(question) {
  return new Promise(resolve => {
    const holderDiv = document.createElement('div')
    // mount then unmount after 1 seconds to trigger loading of all components
    render(
      <Question
        question={question}
        refetchQuestion={() => {}}
        showNextButton={() => {}}
        hideNextButton={() => {}}
      />,
      holderDiv,
    )
    setTimeout(() => unmountComponentAtNode(holderDiv), 1000)
    // continue loading after 10secs
    setTimeout(() => resolve(), 10000)
  })
}



// WEBPACK FOOTER //
// ./src/state/questions/lib.js